const stepModule = {
  // other module props
  id: 1,
  config: {
    header: {
      isTextInCaps: false,
      text: "First interview",
      textColor: {
        label: "Color 1",
        value: "#1D1D1F",
      },
    },
    text: {
      text: "Nachdem wir Deine Bewerbung gesichtet haben, finden wir in einem ersten Interview gemeinsam mit unserem People & Culture Team heraus ob wir zusammen passen.",
      textColor: {
        label: "Color 2",
        value: "#566A7A",
      },
    },
    superline: {
      text: "Step 1",
      textColor: {
        label: "Color 3",
        value: "#86868B",
      },
    },
  },
};

export default stepModule;
